import OneSignal from "react-onesignal";

let initialized = false;

export const __resetOneSignal = () => {
  initialized = false;
};

export const initOneSignal = async () => {
  if (initialized || typeof window === "undefined") return;

  const appId = import.meta.env.VITE_ONESIGNAL_APP_ID as string;
  if (!appId) return;

  await OneSignal.init({
    appId,
    promptOptions: {
      slidedown: {
        prompts: [
          {
            type: "push",
            autoPrompt: true,
            categories: [],
            delay: {
              pageViews: 1,
              timeDelay: 0,
            },
            text: {
              actionMessage: "Deseja receber nossas notificações?",
              acceptButton: "Sim",
              cancelButton: "Agora não",
            },
          },
        ],
      },
    },
  });

  initialized = true;
};
